<app-header-component
  class="box-shadow-bottom"
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>

<ion-content class="ion-padding">
  <div>
    <ng-container *ngFor="let item of descriptions">
      <h4 *ngIf="item?.type" class="fs-4 font700 card-primary-text-color ion-no-margin">
        {{ item?.type }}
      </h4>
      <p *ngIf="item?.text" class="fs-3 font600 card-secondary-text-color">
        {{ item?.text }}
      </p>
    </ng-container>
  </div>
</ion-content>
